import { ICalculatorState } from 'shared/subsidizedCalculator/types/calculator';
import { TSubsidizedCalculatorState } from 'shared/subsidizedCalculator/types/redux';

/** Данные калькулятора в сторе */
export const selectCalculatorValues = (state: TSubsidizedCalculatorState): ICalculatorState => state.calculator;
